// @ts-strict-ignore
// eslint-disable-next-line local-eslint-rules/no-direct-api-hook-access
import { useDashboardApiMutation } from "@services/useDashboardApi";
import useI18nNamespace from "@services/useI18nNamespace";

import { ErrorCode, getErrorMessage } from "./errorCodes";

export const useSubmitRegistrationData = ({
  onSuccess,
  onError,
}: {
  onSuccess: () => void;
  onError: (errorMessage: string) => void;
}) => {
  const { t } = useI18nNamespace("free-trial-registration");
  return useDashboardApiMutation("POST", "/free_trial/submit_registration", {
    options: {
      onSuccess,
      onError: (err) => {
        const errorCode: ErrorCode = err?.responseJson?.error.code ?? ErrorCode.Unknown;
        onError(getErrorMessage(t, errorCode));
      },
    },
    disableDefaultErrorToast: true,
  });
};
